interface StepperHeadlineProps {
  headerText: string;
  subHeaderText: string;
}

export const StepperHeadline = ({
  headerText,
  subHeaderText,
}: StepperHeadlineProps) => {
  return (
    <div className="my-4">
      <h2 className="text-lg">{headerText}</h2>
      <p className="text-sm text-muted-foreground">{subHeaderText}</p>
    </div>
  );
};
